/* eslint-disable @reatom/unit-naming-rule */
import { action, batch, reaction, reatomMap } from '@reatom/framework'

import { isAppVisibleAtom } from '@root/shared/core'

import type { Action } from '@reatom/framework'

export const reatomBufferEvents = <T>({
  event,
  deriveKey,
}: {
  event: Action<[T]>
  deriveKey: (data: T) => string
}) => {
  const bufferMapAtom = reatomMap<string, T>([])

  const emitEventAction = action((ctx, data: T) => {
    const isVisible = ctx.get(isAppVisibleAtom)
    if (!isVisible) {
      const key = deriveKey(data)
      bufferMapAtom.set(ctx, key, data)
      return
    }
    event(ctx, data)
  })

  const isVisibleReaction = reaction((ctx) => {
    const isVisible = ctx.spy(isAppVisibleAtom)
    if (!isVisible) {
      return
    }
    const bufferMap = ctx.get(bufferMapAtom)
    batch(ctx, () => {
      for (const [_, data] of bufferMap) {
        event(ctx, data)
      }
    })
    bufferMapAtom.clear(ctx)
  })

  const initializeAction = action((ctx) => {
    isVisibleReaction(ctx)
  }, 'initializeAction')

  return {
    emitEvent: emitEventAction,
    initializeAction,
  }
}
